{
  "hero.title": "Commutateur d’environnements multi-CLI",
  "hero.tagline-1": "entrez dans un état de flow zen pour programmer.",
  "hero.tagline-2": "changement d’environnement sans friction.",
  "hero.subtitle": "Gestion unifiée des configurations de Claude Code, Codex et OpenCode, avec bascule automatique du proxy d’API",
  "hero.getDocs": "Documentation",
  "features.title": "Fonctionnalités",
  "features.multiCli.title": "Prise en charge multi-CLI",
  "features.multiCli.desc": "Compatible avec Claude Code, Codex et OpenCode, configurable par projet",
  "features.multiConfig.title": "Gestion de configuration",
  "features.multiConfig.desc": "Toutes les configurations de fournisseurs d’API dans un seul fichier JSON",
  "features.daemon.title": "Daemon unifié",
  "features.daemon.desc": "Un seul processus zend héberge le serveur proxy et l’interface web",
  "features.failover.title": "Bascule du proxy",
  "features.failover.desc": "Proxy HTTP intégré, avec bascule automatique quand le fournisseur principal est indisponible",
  "features.routing.title": "Routage par scénario",
  "features.routing.desc": "Routage intelligent selon les caractéristiques de la requête (raisonnement, image, etc.)",
  "features.binding.title": "Liaisons de projet",
  "features.binding.desc": "Liez des répertoires à des profils et des CLI précis pour une configuration automatique par projet",
  "features.envVars.title": "Variables d’environnement",
  "features.envVars.desc": "Configurez les variables d’environnement par CLI au niveau du fournisseur",
  "features.webUi.title": "Interface web",
  "features.webUi.desc": "Gestion visuelle dans le navigateur, protégée par mot de passe",
  "features.webSecurity.title": "Sécurité web",
  "features.webSecurity.desc": "Mot de passe généré automatiquement, authentification par session, chiffrement RSA pour le transport des jetons",
  "features.configSync.title": "Synchronisation de la configuration",
  "features.configSync.desc": "Synchronisez fournisseurs, profils et réglages entre appareils, chiffrés en AES-256-GCM",
  "features.comingSoon": "D’autres fonctionnalités arrivent, restez à l’écoute !",
  "install.title": "Démarrage rapide",
  "install.step1.title": "Installer GoZen",
  "install.step1.desc": "Script d’installation en une ligne",
  "install.step2.title": "Configurer un fournisseur",
  "install.step2.desc": "Ajoutez votre premier fournisseur d’API",
  "install.step3.title": "Lancer",
  "install.step3.desc": "Démarrez la CLI avec la configuration par défaut",
  "commands.title": "Commandes",
  "commands.command": "Commande",
  "commands.description": "Description",
  "commands.items.start": "Lancer la CLI (via la liaison du projet ou la configuration par défaut)",
  "commands.items.profile": "Lancer avec le profil indiqué",
  "commands.items.profilePick": "Sélectionner un profil de façon interactive",
  "commands.items.cli": "Utiliser la CLI indiquée (claude/codex/opencode)",
  "commands.items.yes": "Approuver automatiquement les permissions de la CLI (claude --permission-mode acceptEdits, codex -a never)",
  "commands.items.use": "Utiliser directement le fournisseur indiqué (sans proxy)",
  "commands.items.pick": "Sélectionner un fournisseur de façon interactive",
  "commands.items.list": "Lister tous les fournisseurs et profils",
  "commands.items.configAddProvider": "Ajouter un fournisseur",
  "commands.items.configAddProfile": "Ajouter un profil",
  "commands.items.configDefaultClient": "Définir le client CLI par défaut",
  "commands.items.configDefaultProfile": "Définir le profil par défaut",
  "commands.items.configResetPassword": "Réinitialiser le mot de passe de l’interface web",
  "commands.items.configSync": "Récupérer la configuration depuis le service de synchronisation",
  "commands.items.daemonStart": "Démarrer le daemon zend",
  "commands.items.daemonStop": "Arrêter le daemon",
  "commands.items.daemonStatus": "Afficher l’état du daemon",
  "commands.items.daemonEnable": "Installer le daemon comme service système",
  "commands.items.daemonDisable": "Désinstaller le service système du daemon",
  "commands.items.bind": "Lier le répertoire courant à un profil",
  "commands.items.bindCli": "Lier le répertoire courant à la CLI indiquée",
  "commands.items.unbind": "Délier le répertoire courant",
  "commands.items.status": "Afficher la liaison du répertoire courant",
  "commands.items.web": "Ouvrir l’interface web dans le navigateur (démarre le daemon)",
  "commands.items.upgrade": "Mettre à jour vers la dernière version",
  "commands.items.version": "Afficher la version",
  "commands.items.completion": "Générer la complétion du shell (zsh/bash/fish)",
  "homepage.title": "Commutateur d’environnements multi-CLI"
}
